import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";


export const propertyDetailsApi = async (productId) => {
  try {
    const response = await axios.get(`${baseUrl}property-details/${productId}`);
    return response;
  } catch (error) {
    return null;
  } finally {
  }
};